<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ModelIndex from "@/components/models/index";
import ModelFilter from "@/components/model-filter";
import Stat from "@/components/widgets/stat";

import Swal from "sweetalert2";

import { models } from "./data-models";

export default {
  name: "ViewModel",
  page: {
    title: "Models",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  components: {
    Layout,
    PageHeader,
    ModelIndex,
    ModelFilter,
    Stat
  },
  props: {
    sectionTitle: {
      default() {
        return undefined;
      }
    },
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("models.plural"));
      }
    },
    resourceRoute: { default: "models" },
    modelVariable: { default: "model" }
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("models.plural")),
      items: [
        {
          text: this.lodash.upperFirst(this.$t("models.plural")),
          href: "/models",
          active: true
        }
      ],
      isInitiated: false,
      loading: false,
      page: (this.$route.query.page && Number(this.$route.query.page)) || 1,
      perPage: (this.$route.query.per_page && Number(this.$route.query.per_page)) || 10,
      search: (this.$route.query.search && Number(this.$route.query.search)) || "",
      sortBy:
        (this.$route.query.sort &&
          this.$route.query.sort
            .split("|")
            .shift()
            .split(",")
            .shift()) ||
        "name",
      sortDesc:
        (this.$route.query.sort &&
          this.$route.query.sort
            .split("|")
            .shift()
            .split(",")
            .pop() === "desc") ||
        false,
      busy: false,
      models: [],
      from: 1,
      total: 50,
      filter: {},
      filterColumns: {},
      filterHandler: null,
      stats: [],

      routeQueryWatch: true,
      filterWatch: false,
    };
  },
  mounted() {
    this.initFilter();
    this.filterWatch = true;
  },
  computed: {
    filterParams() {
      let params = {};
      Object.keys(this.filter).forEach(key => {
        if (key.includes(".")) {
          let keys = key.split(".");
          const parent = keys.shift();
          keys = keys.map(key => `[${key}]`).join("");
          params[`${parent}${keys}`] = this.filter[key];
        } else {
          params[key] = this.filter[key];
        }
      });
      return params;
    },
    columns() {
      return {
        [this.modelVariable || "model"]: [
          { key: "index", label: "#", sortable: false, style: { width: "1%" }, tdClass: "align-middle" },
          { key: "action", class: "text-center", style: { width: "1%" }, tdClass: "align-middle" },
          {
            key: "name",
            label: "Name",
            sortable: true,
            tdClass: "align-middle"
          }
        ]
      };
    },
    totalFiltered() {
      return this.total;
    }
  },
  created() {
    Object.keys(this.filterColumns).forEach(key => {
      Object.keys(this.$route.query).forEach(q => {
        if (q.includes(key)) this.filter[q] = this.$route.query[q];
      });
    });
  },
  watch: {
    "$route.query": {
      handler(query) {
        if (!this.routeQueryWatch) return;
        this.perPage = query.per_page ? Number(query.per_page) : 10;
        this.search = query.search || "";
        this.page = query.page ? Number(query.page) : 1;
        this.filterWatch = false;
        this.initFilter();
        this.$nextTick(() => {
          this.filterWatch = true;
        });
      },
      deep: true
    },
    page(value) {
      this.$router.push({
        query: { ...this.$route.query, page: value, per_page: this.perPage, search: this.search || undefined }
      });
    },
    perPage(value) {
      if (this.page !== 1) this.page = 1;
      else
        this.$router.push({
          query: { ...this.$route.query, page: this.page, per_page: value, search: this.search || undefined }
        });
    },
    search(value) {
      if (this.page !== 1) this.page = 1;
      else
        this.$router.push({
          query: { ...this.$route.query, page: this.page, per_page: this.perPage, search: value || undefined }
        });
    },
    sortBy(value) {
      this.$router.push({ query: { ...this.$route.query, sort: `${value},${this.sortDesc ? "desc" : "asc"}` } });
    },
    sortDesc(value) {
      this.$router.push({ query: { ...this.$route.query, sort: `${this.sortBy},${value ? "desc" : "asc"}` } });
    },
    filter(val, oldVal) {
      let isEqual = this.isEqual(this.lodash.cloneDeep(val), this.lodash.cloneDeep(oldVal))
      let isOldValNotEmpty = this.lodash.isEmpty(oldVal)
      if (!this.filterWatch || isEqual || isOldValNotEmpty) return;

      // this.page = 1;
      let filter = {};
      Object.keys(oldVal || {}).forEach(key => {
        filter[key] = (val || {})[key];
      });
      filter = { ...filter, ...(val || {})};
      this.routeQueryWatch = false;
      this.$router.push({ query: { ...this.$route.query, ...filter } }).finally(() => (this.routeQueryWatch = true));
    }
  },
  methods: {
    initFilter() {
      const columns = Object.keys(this.filterColumns);
      const query = this.lodash.pickBy(this.$route.query, (value, key) => columns.find(k => key.startsWith(k)));
      this.$set(this, "filter", {
        ...query
      });
    },
    getModelKey(value) {
      return value[this.modelKey || "id"];
    },
    getModelName(value) {
      return value["name"] || this.getModelKey(value);
    },
    modelsPaginated(ctx) {
      return this.fetchModels(ctx.currentPage).then(() => this.models);
    },
    handleCreate() {
      this.$router.push({ path: `create`, append: true });
    },
    handleExport() {
      this.$router.push({ path: `export`, append: true });
    },
    handleShow(value) {
      this.$router.push({ path: `${this.getModelKey(value)}`, append: true });
    },
    handleEdit(value) {
      this.$router.push({ path: `${this.getModelKey(value)}/edit`, append: true });
    },
    deleteConfirmAlert() {
      return Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t(`You won't be able to revert this!`),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill mx-1",
        cancelButtonClass: "btn btn-danger btn-fill mx-1",
        confirmButtonText: this.$t("Yes, delete it!"),
        cancelButtonText: this.$t("Cancel"),
        buttonsStyling: false
      });
    },
    deleteSuccessAlert(something) {
      return Swal.fire({
        title: this.$t("Deleted") + "!",
        text: this.$t(`You deleted {something}`, { something }),
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill",
        buttonsStyling: false
      });
    },
    failedAlert(error) {
      return Swal.fire({
        title: this.$t("Failed") + "!",
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: "danger",
        confirmButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false
      });
    },
    delete(value) {
      return Promise.resolve({ data: value });
    },
    handleDelete(value) {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete(value)
            .then(() => this.$refs.table.$refs.table.refresh())
            .then(() => this.deleteSuccessAlert(this.getModelName(value)))
            .catch(error => {
              this.failedAlert(error);
              return null;
            });
        }
      });
    },
    fetchModels(page = 1) {
      let perPageModels = this.lodash.chunk(models, this.perPage)[page - 1] || [];
      return Promise.resolve({
        data: {
          data: perPageModels,
          meta: {
            current_page: page,
            per_page: this.perPage,
            from: this.perPage * (page - 1) + 1,
            total: models.length
          }
        }
      })
        .then(response => {
          const {
            data: { data, meta }
          } = response;
          this.models = data.map(datum => ({
            ...datum,
            _denyShow: false,
            _denyEdit: false,
            _denyDelete: false
          }));
          this.page = Number(meta.current_page);
          this.perPage = Number(meta.per_page);
          this.from = Number(meta.from);
          this.total = Number(meta.total);

          return response;
        })
        .catch(error => {
          this.failedAlert(error);
          return null;
        });
    },
    isEqual(a, b) {
      let keysA = Object.keys(a);
      let keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;
      for (let key of keysA) {
        if (!b.hasOwnProperty(key)) return false;
        let valAEmptyOrUndefined = a[key] === '' || a[key] === undefined;
        let valBEmptyOrUndefined = b[key] === '' || b[key] === undefined;
        if (valAEmptyOrUndefined === valBEmptyOrUndefined) {
          continue;
        }
        if (a[key] !== b[key]) return false;
      }

      return true;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader v-if="title" :title="title" :items="items" />
    <div v-if="stats.length" class="row">
      <div v-for="stat of stats" :key="stat.icon" class="col-6 col-md-4 col-xl-3">
        <Stat v-bind="stat" :loading="busy" />
      </div>
    </div>
    <div v-if="!lodash.isEmpty(filterColumns)" class="row">
      <model-filter
        v-model="filter"
        :columns="filterColumns"
        :modelVariable="modelVariable"
        :filterHandler="filterHandler"
      />
    </div>
    <div class="row">
      <model-index
        ref="table"
        class="col-12"
        :loading="loading"
        v-bind="$props"
        :models="models"
        :columns="columns"
        :busy.sync="busy"
        :models-paginated="modelsPaginated"
        :page.sync="page"
        :per-page.sync="perPage"
        :from="from"
        :total="totalFiltered"
        :search.sync="search"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter-params.sync="filterParams"
        @create-click="handleCreate"
        @export-click="handleExport"
        @show-click="handleShow"
        @edit-click="handleEdit"
        @delete-click="handleDelete"
      >
        <!-- <slot name="card-tools" slot="card-tools" /> -->
      </model-index>
    </div>
  </Layout>
</template>
